import { EventsSection } from '~/components/EventsSection'

export default function EventsPage() {
  return (
    <main>
      <section className="page-hero section-pad muted">
        <div className="container">
          <span className="eyebrow">Events &amp; Exhibitions</span>
          <h1 className="page-hero-title">Events</h1>
          <p className="page-hero-desc">
            Trade shows, live demos, exhibitions, and dealer meets hosted or
            participated in by S.J.S. Technology and the VICTORY brand.
          </p>
        </div>
      </section>
      <EventsSection />
    </main>
  )
}
